/** Ayudantes de la pantalla de seguimientos (tanda 3, ola B). PUROS. */
import { ZONA_DEL_NEGOCIO } from './zona';

const TEMAS: Record<string, string> = {
  proxima: 'Caliente: que no se enfríe',
  pensarlo: 'Pidió pensarlo',
  'saludo.lunes': 'Saludo del lunes',
  'saludo.mes': 'Saludo de inicio de mes',
  tomado: 'Chat que tomaste',
  caerle_arriba: 'Cáele arriba',
  siguiente_paso: 'Siguiente paso',
  cumpleanos: 'Cumpleaños',
  'postventa.regalo': 'Postventa: regalo',
  'postventa.video': 'Postventa: video',
  'postventa.referidos': 'Postventa: referidos',
  'postventa.comova': 'Postventa: ¿cómo va?',
  'postventa.aniversario': 'Postventa: aniversario',
  zoom: 'Zoom',
  primer_toque: 'Primer toque (importado)',
};

/** El nombre del tema paral dueño. Uno que no conocemos se muestra tal cual. */
export function etiquetaDeTema(tema: string | null): string {
  return (tema && TEMAS[tema]) || tema || 'Seguimiento';
}

// El equipo trabaja en la hora del negocio: el panel la muestra así aunque se abra desde otro país.
const FORMATO = new Intl.DateTimeFormat('es', { timeZone: ZONA_DEL_NEGOCIO, weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });

export function cuandoLegible(iso: string): string {
  return FORMATO.format(new Date(iso));
}

/** Los grupos de la pantalla, como opciones de la faceta «Cuándo» del superfiltro. */
export const GRUPOS_DE_SEGUIMIENTO = [
  { valor: 'para-aprobar', etiqueta: 'Para aprobar', clave: 'paraAprobar' },
  { valor: 'vencidos', etiqueta: 'Vencidos', clave: 'vencidos' },
  { valor: 'hoy', etiqueta: 'Hoy', clave: 'hoy' },
  { valor: 'semana', etiqueta: 'Esta semana', clave: 'estaSemana' },
] as const;

type Grupos = Record<'paraAprobar' | 'vencidos' | 'hoy' | 'estaSemana' | 'masAdelante', Array<{ tema: string | null; conQuien: string; telefono: string | null; que: string }>>;

/**
 * El superfiltro de Seguimientos (Josué, 14-oct): buscar por persona o por lo que toca,
 * un grupo («Cuándo») y un tema. Un grupo que no se eligió queda vacío. PURO.
 */
export function filtrarSeguimientos<T extends Grupos>(datos: T, f: { buscar?: string; cuando?: string; tema?: string }): T {
  const q = (f.buscar ?? '').trim().toLowerCase();
  const elegido = GRUPOS_DE_SEGUIMIENTO.find((g) => g.valor === f.cuando)?.clave;
  const salida = { ...datos };
  for (const clave of Object.keys(datos) as Array<keyof Grupos>) {
    salida[clave] = (elegido && clave !== elegido
      ? []
      : datos[clave].filter(
          (i) =>
            (!f.tema || i.tema === f.tema) &&
            (!q || `${i.conQuien} ${i.telefono ?? ''} ${i.que}`.toLowerCase().includes(q)),
        )) as T[typeof clave];
  }
  return salida;
}
